"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIconCenter = exports.ButtonIcon = exports.Button = exports.Text = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Text = native_1.default.Text `
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-weight: ${({ theme, type }) => theme.buttons[type].fontWeight ? theme.buttons[type].fontWeight : 'normal'};
  font-size: ${({ size }) => (size === 'small' ? '12px' : '16px')};
  ${({ icon }) => icon && 'padding: 0 58px'};
  color: ${({ theme, type, disabled }) => disabled ? theme.buttons.disabled.text : theme.buttons[type].text};
  text-decoration: ${({ type }) => (type === 'text' ? 'underline' : 'none')};
`;
exports.Button = native_1.default.TouchableOpacity `
  border-radius: ${({ theme, type }) => theme.buttons[type].borderRadius || '28px'};
  height: ${({ size }) => (size === 'small' ? '32px' : '55px')};
  line-height: 55px;
  align-self: stretch;
  justify-content: center;
  background: ${({ theme, type, disabled, color }) => disabled
    ? theme.buttons.disabled.background
    : color || theme.buttons[type].background};
  border: ${({ theme, type, disabled }) => {
    const weight = theme.buttons[type].borderWeight || '1px';
    return !disabled && theme.buttons[type].borderColor
        ? `${weight} solid ${theme.buttons[type].borderColor}`
        : 'none';
}};
`;
exports.ButtonIcon = native_1.default.View `
  position: absolute;
  display: flex;
  justify-content: center;
  left: 0;
  height: 100%;
  padding-left: 19px;
`;
exports.ButtonIconCenter = native_1.default.View `
  margin-right: 10px;
`;
